export const unpackCssShorthand = (shorthand, length = 4) => {
  shorthand = [].concat(shorthand);

  for (let i = 1; i <= length; i++) {
    if (shorthand.length < i) {
      shorthand.push(shorthand[Math.floor(i / 2) - 1]);
    }
  }

  return shorthand;
};
